module.exports = __webpack_public_path__ + "img/achievement_31.a0c605ab.png";